import React from 'react';
import { StoriesContainer } from './containers/StoriesContainer';

export const App = () => <StoriesContainer />;
